import BasicDialog from './BasicDialog';

export default BasicDialog;
